import React, { useEffect, useRef, useState } from 'react'
import Text from 'particles/Text'
import Icon from 'particles/Icon'
import { StyledSnackbarContainer } from './style'
import IconButton from 'particles/Button/IconButton'
import { useWindowSize } from 'hooks'

export type SnackbarContentType = 'positive' | 'error'

interface SnackbarProps {
    text: string
    type: SnackbarContentType
}
const defaultMaxWidth = 668 // 700 - 32px padding

const Snackbar: React.FC<SnackbarProps> = ({ text, type }) => {
    const windowWidth = useWindowSize()
    const textRef = useRef<HTMLDivElement | null>(null)
    const [containerWidth, setContainerWidth] = useState(200) // Initial minimum width
    const maxWidth = windowWidth - 32 < defaultMaxWidth ? windowWidth - 32 : defaultMaxWidth

    useEffect(() => {
        const textWidth = textRef.current ? textRef.current.scrollWidth : 200
        const calculatedWidth = Math.min(maxWidth, textWidth + 88) // 88 is calculated padding/gap
        setContainerWidth(calculatedWidth)
    }, [text])

    return (
        <StyledSnackbarContainer form={type} wrap={containerWidth >= maxWidth} width={`${containerWidth}px`}>
            <div className="icon-content-container">
                {type === 'positive' && <Icon name={'checkCircle'} className="icon" size={'24px'} color={type} />}
                {type === 'error' && <Icon name={'xCircle'} className="icon" size={'24px'} color={type} />}

                <div className="text-container">
                    <Text
                        scale={'bodyS500'}
                        color={'primary'}
                        className="text-component"
                        ref={textRef}
                        data-testid="test-snackbar-title"
                    >
                        {text}
                    </Text>
                </div>
            </div>
            <IconButton
                icon="x"
                size="s"
                type="button"
                form="icon"
                color="neutral"
                dataTestId="test-toast-close-button"
            />
        </StyledSnackbarContainer>
    )
}

export default Snackbar
